module.exports = __webpack_public_path__ + "media/images/icons/google-color-e227ec5b6fdde0ae322da83ac14b4836.svg";